themeBase.requestIdleCallback(() => {
  /* Footbar docks to the bottom, so it no longer competes with the sticky
     header for the top of the viewport — leave sticky header enabled. */
  themeBase.onDOMContentLoadedTrigger(() => {
    scriptController.executeWhenScriptLoaded(['cart.js', 'product-form.js'], () => {
      if (!customElements.get('product-footbar')) {
        class ProductFootbar extends HTMLElement {
          constructor() {
            super();

            this.product = document.querySelector('.product');
            this.productButtonAddToCart = this.product.querySelector('[name="add"]');
            this.variants = this.querySelector('[name="id"]');

            this.variants.addEventListener('change', this.onChange.bind(this));
            window.addEventListener('MutationObserverLoaded', this.checkOverlay.bind(this));
            window.addEventListener('throttle30fpsMove', this.checkOverlay.bind(this));
          }

          onChange(event) {
            const options = event.target.querySelectorAll('option');
            const productVariantSwitcher = document.querySelector(`variant-radios[data-section="${this.dataset.sectionId}"]`) || document.querySelector(`variant-selects[data-section="${this.dataset.sectionId}"]`);

            options.forEach(element => {
              if (element.selected) {
                const variantData = JSON.parse(this.product.querySelector('[type="application/json"]').textContent);
                const currentVariant = variantData.variants.filter((variant) => {
                  return variant.id == element.value;
                })[0];

                productVariantSwitcher.changeOptions(currentVariant.options);
                productVariantSwitcher.onVariantChange({
                  isFootbar: true
                });
                return false;
              }
            });
          }

          isComboMode() {
            return this.classList.contains('is-repod-combo-mode') ||
              this.getAttribute('data-repod-footbar-mode') === 'combo';
          }

          /* RePod More Savings tab: the in-flow Product ATC is inside a hidden
             panel, so its bounds are zero. Use the checklist "Add Bundle" CTA
             as the scroll sentinel instead. */
          getSentinel() {
            if (!this.isComboMode()) return this.productButtonAddToCart;

            const sectionId = this.dataset.sectionId;
            const selector = sectionId
              ? `.repod-cl[data-section-id="${sectionId}"] [data-repod-cl-add]`
              : '[data-repod-cl-add]';

            return document.querySelector(selector) || this.productButtonAddToCart;
          }

          checkOverlay() {
            const sentinel = this.getSentinel();
            if (!sentinel) return;

            const sentinelBound = this.isComboMode() ? themeBounds.get(sentinel, true) : themeBounds.get(sentinel);
            const isVisible = sentinelBound.bottom < 0;

            this.classList[isVisible ? 'add' : 'remove']('product-footbar__wrapper--visible');

            if (isVisible) {
              document.documentElement.style.setProperty('--product-footbar-height', `${themeBounds.get(this).height.toFixed(1) / 10}rem`);
            } else {
              document.documentElement.style.setProperty('--product-footbar-height', '');
            }
          }
        }

        customElements.define('product-footbar', ProductFootbar);
      }
    });
  });
});
